import { type SVGProps } from 'react'

export function AwardIcon(props: SVGProps<SVGSVGElement>) {
  const color = props.color ?? '#fff'

  return (
    <svg fill="none" height={16} viewBox="0 0 16 16" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2105_107077)">
        <path
          d="M4.76 10.004v4.479l3.048-1.22c.071-.028.107-.043.144-.048a.324.324 0 0 1 .098 0c.037.005.072.02.143.048l3.049 1.22v-4.479m1.62-3.623a4.861 4.861 0 1 1-9.722 0 4.861 4.861 0 0 1 9.722 0Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.296}
        />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M.223.223h15.556v15.556H.223z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  )
}
